import { ServiceAnalyticsSummary } from '../types';

// Demo fixture for the Analytics tab.
//
// These are REAL figures, not invented ones: a full pass over all 95,944
// conversations of the CallCenterEN research corpus in the Experimental
// territory, run 2026-08-27. Every conversation was read once, its dialog
// matched against sixteen phrase lists and a nine-industry vocabulary
// classifier, and duplicates removed by transcript hash. No sampling.
//
// It lives in the bundle rather than behind an endpoint because the analytics
// endpoint does not exist yet. The page asks the API first and falls back to
// this, so the day /api/analytics_summary.php ships returning
// ServiceAnalyticsSummary for the selected scope, the page starts showing live
// numbers with no change here — and the demo badge disappears on its own,
// which is the point: nothing has to remember to remove it.
//
// Regenerating: the scan lives outside this repo (it reads the corpus files
// directly under callcenter_en/vcons_out/). Treat this file as data, not as
// something to hand-edit — a number nudged here is a number that no longer
// matches the corpus.

export const DEMO_ANALYTICS: ServiceAnalyticsSummary = {
  "generatedAt": "2026-08-27",
  "scope": {
    "territory": "Experimental",
    "domain": null
  },
  "corpus": {
    "callsTotal": 95944,
    "callsUnique": 90433,
    "duplicates": 5511,
    "hours": 10255,
    "medianSeconds": 319,
    "p90Seconds": 701,
    "asrConfidence": 0.893,
    "industries": 9
  },
  "bands": [
    "under 2 min",
    "2–5 min",
    "5–10 min",
    "10–20 min",
    "20 min +"
  ],
  "industries": [
    {
      "name": "Telecom / internet",
      "calls": 819,
      "inboundPct": 24,
      "medianSeconds": 606,
      "p90Seconds": 1544,
      "wordsPerMinute": 130,
      "asrConfidence": 0.882,
      "durationBands": [
        0.4,
        14.5,
        33.9,
        31.6,
        19.5
      ],
      "signals": {
        "disclosure": 28.9,
        "hold": 58.7,
        "transfer": 7.9,
        "repeat": 1.5,
        "apology": 49.2,
        "frustration": 4.3,
        "gratitude": 63.5,
        "anythingElse": 26.1,
        "confirmed": 19.4,
        "deferral": 6.0,
        "callback": 21.1,
        "churn": 0.7,
        "optOut": 4.5,
        "appointment": 30.4,
        "payment": 33.2,
        "empathy": 23.2
      },
      "residual": false
    },
    {
      "name": "Auto & property insurance",
      "calls": 5206,
      "inboundPct": 72,
      "medianSeconds": 489,
      "p90Seconds": 1397,
      "wordsPerMinute": 112,
      "asrConfidence": 0.921,
      "durationBands": [
        0.0,
        19.3,
        42.4,
        25.3,
        12.9
      ],
      "signals": {
        "disclosure": 33.2,
        "hold": 59.7,
        "transfer": 21.7,
        "repeat": 2.3,
        "apology": 53.6,
        "frustration": 3.7,
        "gratitude": 44.0,
        "anythingElse": 17.6,
        "confirmed": 14.5,
        "deferral": 8.7,
        "callback": 15.1,
        "churn": 0.6,
        "optOut": 1.9,
        "appointment": 17.4,
        "payment": 37.2,
        "empathy": 19.8
      },
      "residual": false
    },
    {
      "name": "Auto dealership & service",
      "calls": 6011,
      "inboundPct": 95,
      "medianSeconds": 445,
      "p90Seconds": 930,
      "wordsPerMinute": 125,
      "asrConfidence": 0.927,
      "durationBands": [
        0.0,
        25.0,
        44.0,
        26.3,
        4.6
      ],
      "signals": {
        "disclosure": 14.2,
        "hold": 62.8,
        "transfer": 16.1,
        "repeat": 2.2,
        "apology": 45.3,
        "frustration": 5.0,
        "gratitude": 42.8,
        "anythingElse": 12.7,
        "confirmed": 10.3,
        "deferral": 11.6,
        "callback": 16.0,
        "churn": 0.1,
        "optOut": 1.5,
        "appointment": 12.6,
        "payment": 28.8,
        "empathy": 17.6
      },
      "residual": false
    },
    {
      "name": "Dental / medical office",
      "calls": 4663,
      "inboundPct": 100,
      "medianSeconds": 387,
      "p90Seconds": 785,
      "wordsPerMinute": 114,
      "asrConfidence": 0.886,
      "durationBands": [
        0.0,
        30.0,
        48.9,
        19.0,
        2.1
      ],
      "signals": {
        "disclosure": 10.2,
        "hold": 52.2,
        "transfer": 4.1,
        "repeat": 2.4,
        "apology": 45.3,
        "frustration": 2.7,
        "gratitude": 46.4,
        "anythingElse": 15.6,
        "confirmed": 16.0,
        "deferral": 6.9,
        "callback": 8.1,
        "churn": 0.6,
        "optOut": 0.6,
        "appointment": 37.4,
        "payment": 24.4,
        "empathy": 10.1
      },
      "residual": false
    },
    {
      "name": "Medical equipment / supplies",
      "calls": 643,
      "inboundPct": 95,
      "medianSeconds": 384,
      "p90Seconds": 837,
      "wordsPerMinute": 109,
      "asrConfidence": 0.887,
      "durationBands": [
        0.0,
        30.9,
        45.9,
        19.8,
        3.4
      ],
      "signals": {
        "disclosure": 1.9,
        "hold": 51.0,
        "transfer": 7.9,
        "repeat": 3.1,
        "apology": 49.5,
        "frustration": 3.7,
        "gratitude": 40.3,
        "anythingElse": 24.1,
        "confirmed": 14.6,
        "deferral": 7.2,
        "callback": 7.2,
        "churn": 0.6,
        "optOut": 1.1,
        "appointment": 41.5,
        "payment": 27.8,
        "empathy": 9.5
      },
      "residual": false
    },
    {
      "name": "Health plan / Medicare",
      "calls": 5789,
      "inboundPct": 30,
      "medianSeconds": 377,
      "p90Seconds": 749,
      "wordsPerMinute": 121,
      "asrConfidence": 0.93,
      "durationBands": [
        0.1,
        31.4,
        50.5,
        15.5,
        2.4
      ],
      "signals": {
        "disclosure": 18.7,
        "hold": 48.5,
        "transfer": 18.9,
        "repeat": 0.8,
        "apology": 32.4,
        "frustration": 1.7,
        "gratitude": 51.3,
        "anythingElse": 5.7,
        "confirmed": 5.1,
        "deferral": 4.3,
        "callback": 6.8,
        "churn": 0.2,
        "optOut": 2.7,
        "appointment": 10.4,
        "payment": 23.8,
        "empathy": 9.5
      },
      "residual": false
    },
    {
      "name": "Pet services",
      "calls": 17320,
      "inboundPct": 100,
      "medianSeconds": 345,
      "p90Seconds": 728,
      "wordsPerMinute": 121,
      "asrConfidence": 0.888,
      "durationBands": [
        0.0,
        38.6,
        44.6,
        15.0,
        1.7
      ],
      "signals": {
        "disclosure": 8.6,
        "hold": 41.6,
        "transfer": 2.1,
        "repeat": 1.8,
        "apology": 41.4,
        "frustration": 1.7,
        "gratitude": 50.1,
        "anythingElse": 17.4,
        "confirmed": 21.9,
        "deferral": 3.4,
        "callback": 5.7,
        "churn": 0.2,
        "optOut": 0.2,
        "appointment": 21.5,
        "payment": 12.5,
        "empathy": 7.7
      },
      "residual": false
    },
    {
      "name": "Home services (HVAC / plumbing)",
      "calls": 557,
      "inboundPct": 87,
      "medianSeconds": 336,
      "p90Seconds": 602,
      "wordsPerMinute": 115,
      "asrConfidence": 0.887,
      "durationBands": [
        0.2,
        39.9,
        49.6,
        9.5,
        0.9
      ],
      "signals": {
        "disclosure": 5.0,
        "hold": 37.2,
        "transfer": 3.1,
        "repeat": 2.5,
        "apology": 39.5,
        "frustration": 1.6,
        "gratitude": 46.7,
        "anythingElse": 35.9,
        "confirmed": 10.2,
        "deferral": 8.6,
        "callback": 13.8,
        "churn": 0.0,
        "optOut": 0.7,
        "appointment": 32.1,
        "payment": 12.6,
        "empathy": 11.3
      },
      "residual": false
    },
    {
      "name": "Retail / order support",
      "calls": 1327,
      "inboundPct": 89,
      "medianSeconds": 334,
      "p90Seconds": 732,
      "wordsPerMinute": 114,
      "asrConfidence": 0.896,
      "durationBands": [
        0.5,
        40.9,
        42.0,
        14.5,
        2.0
      ],
      "signals": {
        "disclosure": 17.9,
        "hold": 53.7,
        "transfer": 7.5,
        "repeat": 3.4,
        "apology": 38.1,
        "frustration": 3.1,
        "gratitude": 42.5,
        "anythingElse": 18.1,
        "confirmed": 13.3,
        "deferral": 6.7,
        "callback": 12.7,
        "churn": 0.4,
        "optOut": 0.3,
        "appointment": 22.5,
        "payment": 29.8,
        "empathy": 10.3
      },
      "residual": false
    },
    {
      "name": "Mixed / multi-industry",
      "calls": 2821,
      "inboundPct": 79,
      "medianSeconds": 494,
      "p90Seconds": 1099,
      "wordsPerMinute": 120,
      "asrConfidence": 0.904,
      "durationBands": [
        0.1,
        17.9,
        44.4,
        29.7,
        7.8
      ],
      "signals": {
        "disclosure": 18.8,
        "hold": 57.1,
        "transfer": 14.6,
        "repeat": 3.1,
        "apology": 49.6,
        "frustration": 4.3,
        "gratitude": 49.0,
        "anythingElse": 17.1,
        "confirmed": 15.7,
        "deferral": 7.5,
        "callback": 12.3,
        "churn": 0.3,
        "optOut": 2.3,
        "appointment": 25.5,
        "payment": 29.5,
        "empathy": 16.2
      },
      "residual": true
    },
    {
      "name": "Unclassified",
      "calls": 45277,
      "inboundPct": 95,
      "medianSeconds": 273,
      "p90Seconds": 509,
      "wordsPerMinute": 101,
      "asrConfidence": 0.882,
      "durationBands": [
        0.6,
        58.2,
        35.6,
        5.3,
        0.3
      ],
      "signals": {
        "disclosure": 10.7,
        "hold": 45.4,
        "transfer": 4.8,
        "repeat": 1.9,
        "apology": 38.4,
        "frustration": 1.3,
        "gratitude": 41.7,
        "anythingElse": 18.4,
        "confirmed": 13.6,
        "deferral": 5.8,
        "callback": 8.4,
        "churn": 0.4,
        "optOut": 0.2,
        "appointment": 30.6,
        "payment": 11.9,
        "empathy": 6.3
      },
      "residual": true
    }
  ],
  "drivers": [
    {
      "signal": "frustration",
      "label": "Frustration language",
      "sharePct": 2.0,
      "medianWith": 507,
      "medianWithout": 317
    },
    {
      "signal": "transfer",
      "label": "Call includes a transfer",
      "sharePct": 7.3,
      "medianWith": 410,
      "medianWithout": 314
    },
    {
      "signal": "repeat",
      "label": "Customer says they called before",
      "sharePct": 1.9,
      "medianWith": 374,
      "medianWithout": 318
    },
    {
      "signal": "resolution",
      "label": "Confirmation / \"all set\" language",
      "sharePct": 14.7,
      "medianWith": 368,
      "medianWithout": 312
    },
    {
      "signal": "hold",
      "label": "Hold / \"let me check\" language",
      "sharePct": 47.8,
      "medianWith": 364,
      "medianWithout": 289
    },
    {
      "signal": "unresolved",
      "label": "Deferral to a call-back",
      "sharePct": 5.9,
      "medianWith": 341,
      "medianWithout": 318
    }
  ],
  "labelMix": [
    {
      "label": "medicare_inbound",
      "calls": 60855,
      "parts": [
        {
          "name": "Unclassified",
          "pct": 53.6
        },
        {
          "name": "Pet services",
          "pct": 28.2
        },
        {
          "name": "Dental / medical office",
          "pct": 7.7
        },
        {
          "name": "Auto & property insurance",
          "pct": 3.2
        },
        {
          "name": "everything else",
          "pct": 7.3
        }
      ]
    },
    {
      "label": "home_service_inbound",
      "calls": 11364,
      "parts": [
        {
          "name": "Unclassified",
          "pct": 75.8
        },
        {
          "name": "Auto dealership",
          "pct": 6.1
        },
        {
          "name": "Retail / orders",
          "pct": 5.1
        },
        {
          "name": "Auto insurance",
          "pct": 4.6
        },
        {
          "name": "everything else",
          "pct": 8.4
        }
      ]
    },
    {
      "label": "automotive_inbound",
      "calls": 5181,
      "parts": [
        {
          "name": "Auto dealership & service",
          "pct": 64.6
        },
        {
          "name": "Unclassified",
          "pct": 25.4
        },
        {
          "name": "Mixed",
          "pct": 5.0
        },
        {
          "name": "everything else",
          "pct": 5.0
        }
      ]
    },
    {
      "label": "insurance_outbound",
      "calls": 3996,
      "parts": [
        {
          "name": "Health plan / Medicare",
          "pct": 92.2
        },
        {
          "name": "Mixed",
          "pct": 4.8
        },
        {
          "name": "Unclassified",
          "pct": 1.9
        },
        {
          "name": "everything else",
          "pct": 1.1
        }
      ]
    },
    {
      "label": "home_ervice_inbound&telecom_outbound",
      "calls": 3111,
      "parts": [
        {
          "name": "Unclassified",
          "pct": 57.9
        },
        {
          "name": "Telecom / internet",
          "pct": 19.9
        },
        {
          "name": "Auto dealership",
          "pct": 5.3
        },
        {
          "name": "Auto insurance",
          "pct": 4.8
        },
        {
          "name": "everything else",
          "pct": 12.1
        }
      ]
    },
    {
      "label": "customer_service_general_inbound",
      "calls": 1217,
      "parts": [
        {
          "name": "Auto & property insurance",
          "pct": 95.1
        },
        {
          "name": "Unclassified",
          "pct": 2.4
        },
        {
          "name": "everything else",
          "pct": 2.5
        }
      ]
    },
    {
      "label": "medical_equipment_outbound",
      "calls": 738,
      "parts": [
        {
          "name": "Health plan / Medicare",
          "pct": 46.1
        },
        {
          "name": "Unclassified",
          "pct": 17.8
        },
        {
          "name": "Mixed",
          "pct": 17.6
        },
        {
          "name": "Auto dealership",
          "pct": 10.0
        },
        {
          "name": "Medical equipment",
          "pct": 4.6
        },
        {
          "name": "everything else",
          "pct": 3.9
        }
      ]
    }
  ],
  "capabilities": {
    "measured": [
      {
        "title": "Handle time",
        "detail": "Real audio duration per call — median, p90 and the full length distribution."
      },
      {
        "title": "Talk density",
        "detail": "Words per minute of audio. A low value means hold, dead air or IVR, not a quiet customer."
      },
      {
        "title": "Hold and transfer",
        "detail": "\"Let me pull that up\", \"I'll transfer you\" — the two cheapest customer-effort signals there are."
      },
      {
        "title": "Recording disclosure",
        "detail": "Whether the call opened with the monitored-or-recorded notice. A genuine compliance rate."
      },
      {
        "title": "Topic mix",
        "detail": "What people actually call about, classified from the transcript rather than the dial plan."
      },
      {
        "title": "Transcription quality",
        "detail": "Per-call ASR confidence — the gate on everything else on this page."
      }
    ],
    "proxy": [
      {
        "title": "Satisfaction",
        "detail": "Inferred from gratitude against frustration vocabulary. There is no CSAT, NPS or survey anywhere in the platform."
      },
      {
        "title": "Resolution",
        "detail": "Inferred from close-out language (\"you're all set\", a confirmation number) against deferral (\"someone will call you back\")."
      },
      {
        "title": "Agent empathy",
        "detail": "\"I understand\", \"I hear you\". Counts phrases, not sincerity."
      },
      {
        "title": "Repeat contact",
        "detail": "Only when the customer says so out loud. Joining calls by party would need a caller identity this corpus does not carry."
      }
    ],
    "unavailable": [
      {
        "title": "Escalation to a supervisor",
        "detail": "The PII redactor replaces every job title with [occupation]. \"Supervisor\" appears 0 times in 6,000 sampled calls."
      },
      {
        "title": "Agent-level performance",
        "detail": "Speaker labels are None on every word, so agent and customer speech cannot be separated."
      },
      {
        "title": "Trend over time",
        "detail": "Every created_at in this corpus is an epoch placeholder (1970/1971)."
      },
      {
        "title": "Revenue, order value, refunds",
        "detail": "[money_amount] is redacted throughout."
      },
      {
        "title": "Queue time, abandon rate, occupancy",
        "detail": "No telephony events — only the recorded audio exists."
      },
      {
        "title": "Comparison between companies",
        "detail": "[organization] is redacted, so brands cannot be told apart."
      }
    ]
  }
};
